<template>
  <div class="main" v-loading="loading">
    <div class="gong_neng">
      <el-button @click="goPage">返回</el-button>
    </div>
    <div>
      <el-table :data="tableData" border>
        <el-table-column
          v-for="(item, index) in title"
          :key="index"
          :prop="item.field"
          :label="item.name"
        >
        </el-table-column>
      </el-table>
    </div>
    <div class="page">
      <el-pagination
        background
        layout="prev, pager, next"
        :total="user_count"
        :current-page="pageCurrent"
        @current-change="onChange"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import { require } from "@/utils/http_request.js";
export default {
  data() {
    return {
      tableData: [],
      title: [],
      page: 0,
      user_count: 0,
      loading: true,
      pageCurrent:1
    };
  },
  created() {
    this.tableDat();
  },
  methods: {
    goPage() {
      this.$router.go(-1);
    },
    onChange(val) {
      this.pageCurrent = val;
      this.loading = true;
      this.page = val - 1;
      this.tableDat();
    },
    tableDat() {
      let obj = {
        page: this.page
      };
      require("post", "/hr24_index_data/v1/pay_user/", obj).then(res => {
        console.log(res);
        if (res.code == 0) {
          this.tableData = res.data.return_data;
          this.title = res.data.title;
          this.loading = false;
          this.user_count = res.data.user_count;
        }
      });
    }
  }
};
</script>
<style scoped>
.main {
  margin-top: 46px;
  margin-left: 229px;
  background: #ffff;
  min-height: 70vh;
  margin-bottom: 20px;
  width: 80vw;
  border-radius: 4px;
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.08);
  padding: 50px;
}
.gong_neng {
  padding: 12px 0;
}
.page {
  padding: 12px 0;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/index/rechargerecord.vue